<main class="component-wrapper">
    <div class="component-content" id="main-content">
        <header>
            <h1 class="title" [innerHTMLBypassXSS]="title"></h1>
            <p class="subtitle" [innerHTMLBypassXSS]="subtitle"></p>
        </header>
        <div class="sorting" *ngIf="showList">
            <div class="sorting-dropdown" >
                <kendo-label class="form-label" [for]="sort" text="{{'anfrageoverview.sortcriterialabel' | translate}}" [infotooltip]="'anfrageoverview.sortcriteria'">
                </kendo-label>
                <kendo-dropdownlist #sort [(ngModel)]="sortSelection" [valuePrimitive]="true" #anrede
                    [data]="sortSelectionList" [valueField]="'Value'" [textField]="'Description'" (valueChange)="onSortSelectionChange($event)"
                    [filterable]="false" [appinfotext]="'anfrageoverview.sortcriteria'">
                </kendo-dropdownlist>
            </div>
            <div class="filterTitleAndNumber" >
                <kendo-label class="form-label" [for]="filter" [infotooltip]="'anfrageoverview.titlefilter'"
                        [text]="('anfrageoverview.titelfilterlabelone' | translate : {placeholder: '(' + anfragen.length + '/'+ unfilteredAnfragen.length+')'})" > 
                </kendo-label>
                <kendo-textbox #filter placeholder="{{'anfrageoverview.titelfilterplaceholder' | translate }}" [(ngModel)]="filterTitles"
                    (ngModelChange)="onfilterTitlesChange($event)" [appinfotext]="'anfrageoverview.titlefilter'">
                </kendo-textbox>
            </div>
        </div>
        <div class="list">
            <ng-container *ngIf="showList">
                <div *ngFor="let item of anfragen">
                     <ng-container *ngComponentOutlet="anfrageCardComponent, inputs: {
                        anfrage: item,
                        onAnfrageDelete: onAnfrageDelete
                    }"></ng-container> 
                </div>
            </ng-container>
        </div>
        <span *ngIf="!showList" translate>request.none_available</span>
    </div>
</main>
